import React, { useEffect, useState } from 'react';
import { CafClusterSample, getEmailPreview } from '../../../api/cafCorpus';
import { Modal } from '../Overlay';
import { EmailPreviewPane } from '../teach/EmailPicker';

/** Mounted only on Read email; the shared preview endpoint is read-only. */
export const DecisionEmailModal: React.FC<{ taskId: string; onClose: () => void }> = ({ taskId, onClose }) => {
  const [preview, setPreview] = useState<CafClusterSample | null>(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setFailed(false);
    const load = async () => {
      try {
        const email = await getEmailPreview(taskId);
        if (active) setPreview(email);
      } catch {
        if (active) setFailed(true);
      } finally {
        if (active) setLoading(false);
      }
    };
    void load();
    return () => { active = false; };
  }, [taskId, attempt]);

  return (
    <Modal title="Read email" size="wide" onClose={onClose}>
      {failed ? (
        <div role="alert">
          <p>Couldn't load this email.</p>
          <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm"
            onClick={() => setAttempt((value) => value + 1)}>Try again</button>
        </div>
      ) : (
        <EmailPreviewPane preview={preview} loading={loading} footer={preview?.truncated
          ? <p className="cur-hint">This email is truncated. The preview shows only the first part of the message.</p>
          : undefined} />
      )}
    </Modal>
  );
};
